import { Loader2 } from 'lucide-react'
import * as React from 'react'

/**
 * A spinning loader. Animates an HTML wrapper so browsers can run the
 * animation on the compositor while the main thread is busy. Accepts the
 * same props as Loader2; `className` is applied to the icon so size, color,
 * and other utilities still compose normally.
 */
function Spinner({
  className,
  ...props
}: React.ComponentProps<typeof Loader2>) {
  return (
    <span className='inline-flex animate-spin will-change-transform'>
      <Loader2 data-slot='spinner' className={className} {...props} />
    </span>
  )
}

export { Spinner }
